import React, { FC } from 'react'

import { Switch } from 'react-router-dom'

import McpConsent from 'components_new/pages/McpConsent'

import { useIsAuthenticated } from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'

const Routes: FC = () => {
  const isAuthenticated = useIsAuthenticated()

  return (
    <Switch>
      <AuthRoute
        Component={() => <McpConsent />}
        isAuthenticated={isAuthenticated}
        path={'/mcp/consent'}
      />
    </Switch>
  )
}

export default Routes
